export { default as FixedThead } from './FixedThead';
